type FillProps = {
  color?: string;
  selected?: boolean;
  size?: number;
};

const Fill = ({ color = 'grey', selected, size }: FillProps) => {
  const getFill = (color: string, selected: boolean) => {
    if (color !== 'none') return color;
    return selected ? 'rgb(227, 209, 253)' : 'rgba(234, 234, 237, 1)';
  };

  const getStroke = (color: string, selected: boolean) => {
    if (selected) return 'rgb(127, 48, 245)';
    return color === 'none' ? 'rgba(109, 109, 130, 1)' : color;
  };

  const fill = getFill(color, selected ?? false);
  const stroke = getStroke(color, selected ?? false);
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1914_5576)">
        <path
          d="M20 2.5H4C3.17157 2.5 2.5 3.17157 2.5 4V20C2.5 20.8284 3.17157 21.5 4 21.5H20C20.8284 21.5 21.5 20.8284 21.5 20V4C21.5 3.17157 20.8284 2.5 20 2.5Z"
          stroke={stroke}
          fill={fill}
        />
        {color === 'none' && (
          <path d="M4 20L20 4" stroke="#E93A51" strokeWidth="2" strokeLinecap="round" />
        )}
      </g>
      <defs>
        <clipPath id="clip0_1914_5576">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Fill;
